import Typography from '../../common/Typography';

export default Typography;
